import PointIcon from "@assets/images/box-export.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TextAreaField from "@saleor/components/TextAreaField";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import uniq from "lodash/uniq";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface addressInterface {
  id: string;
  unloadingPoint: string;
}
export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  address: addressInterface[] | null;
  formik?: FormikProps<any>;
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "5",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px",
      marginLeft: "15px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    buttonActions: {
      width: "89%",
      marginLeft: 20,
      padding: "8px 0px 2px 0px",
      gap: 8
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const { visible, onClose, address, formik } = props;
  const [shipping, setShipping] = useState<string>(() => {
    if (Array.isArray(address)) {
      const hasUnloadingPoint = address.some(
        item => item.unloadingPoint === formik?.values?.unloadingPoint
      );
      return hasUnloadingPoint ? formik?.values?.unloadingPoint : "";
    }
    return "";
  });
  const [shippingId, setShippingId] = useState<string>(
    (Array.isArray(address) &&
      address?.find(
        item => item.unloadingPoint === formik?.values?.unloadingPoint
      )?.id) ||
      ""
  );
  const [unloadingValue, setUnloadingValue] = useState<string>(() => {
    if (
      Array.isArray(address) &&
      address.some(
        item => item.unloadingPoint === formik?.values?.unloadingPoint
      )
    ) {
      return "";
    }
    return formik?.values?.unloadingPoint || "";
  });
  const classes = useStyles();
  const intl = useIntl();
  const maxLength = shipping.trim()
    ? Math.max(25 - shipping.trim().length, 0)
    : 25;
  function handleChange(event) {
    setUnloadingValue(event.target.value);
  }
  const dataRenderModal = {
    iconHead: PointIcon,
    nameHead: intl.formatMessage({
      defaultMessage: "Unloading Point"
    })
  };
  const handleSubmit = () => {
    formik.setFieldValue("unloadingPoint", shipping?.trim() + unloadingValue);
    onClose();
  };

  const onSelect = e => {
    const selectedUnloadingPoint =
      address.find(item => item.id === e.target.value)?.unloadingPoint || "";
    if (selectedUnloadingPoint?.length + unloadingValue?.length > 25) {
      return;
    }
    if (shippingId === e.target.value) {
      setShipping("");
      setShippingId("");
    } else {
      setShipping(selectedUnloadingPoint);
      setShippingId(e.target.value);
    }
  };
  return (
    <>
      <Dialog
        open={visible}
        className={classes.root}
        data-testid="modalAddressUnloading"
      >
        <DialogTitle className={classes.dialogTitle}>
          <h2 className={classes.dialogTitleWrap}>
            <img src={dataRenderModal?.iconHead} alt="" />
            <MyTypography variant={"h6"} className={classes.nameHead}>
              {dataRenderModal?.nameHead}&nbsp;
              <span className={classes.rowlength}>({address?.length})</span>
            </MyTypography>
          </h2>
        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={shippingId}
                  onClick={e => {
                    onSelect(e);
                  }}

                  // defaultValue={formik.values.unloadingPoint}
                >
                  {uniq(address).map((value, index) => (
                    <FormControlLabel
                      className={classes.formControlLabel}
                      key={index}
                      value={value.id}
                      control={<Radio />}
                      label={value.unloadingPoint}
                      disabled={unloadingValue?.length === 25}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <MyTypography variant={"subtitle3"} style={{ marginLeft: 20 }}>
          {intl.formatMessage({
            defaultMessage: "ระบุจุดขนถ่ายสินค้า"
          })}
        </MyTypography>
        <TextAreaField
          name="พิมพ์ที่นี่..."
          onChange={handleChange}
          value={unloadingValue}
          title={null}
          maxLength={maxLength}
          lineLimit={132}
          rowsMax={10}
          className={classes.buttonActions}
          disabled={maxLength === 0}
          id="unloadingField"
          data-testid="unloading-input"
        />
        <DialogActions>
          <Button
            id="cancelButton"
            data-testid="cancelButton"
            variant={"outlined"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={onClose}
          >
            <FormattedMessage defaultMessage={"ยกเลิก"} />
          </Button>
          <Button
            id="submitButton"
            data-testid="submitButton"
            variant={"contained"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={handleSubmit}
          >
            <FormattedMessage defaultMessage={"ตกลง"} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalAddress;
